module.exports = __webpack_public_path__ + "static/img/develop.f938be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/develop.png
// module id = X7H2
// module chunks = 44